<template>
    <div class="suggest-search" ref="suggest-search">
        <transition name="fade" appear>
            <form class="suggest-search__form">
                <input
                    class="suggest-search__field"
                    :placeholder="setPlaceholder"
                    type="text"
                    maxlength="50"
                    :name="$attrs.name || 'query'"
                    v-model="query"
                    ref="input"
                    @input="makeSuggest"
                    @click="openSuggest"
                    autocomplete="off"
                    v-bind="$attrs"
                >
                <button type="submit" class="suggest-search__button text-light">
                    <svg v-if="!isSuggestLoading" width="24" height="24">
                        <use xlink:href="/sprite.svg#icon-search"></use>
                    </svg>
                    <span v-else class="spinner-border spinner-border-sm" />
                </button>
            </form>
        </transition>

        <div :class="suggestResultClassNames" v-if="suggestComponent">
            <component :is="suggestComponent" :suggest-data="suggestData"></component>
        </div>
    </div>
</template>

<script>

/**
 * suggestComponent -- сюда нужно передавать имя компонента,
 * по умолчанию -- suggest-result-simple
 *
 * Сам компонент вывода подсказок (саджестов) нужно отдельно задать
 * и подключить в local/js/specialty/src/scripts/components/init-components.js
 */

import { ajaxRequest } from '../../../services/ajax-service';
import { globalErrorHandler } from '../../../services/error-handling';

const START_SUGGEST_SYMBOLS = 2;

let REQUEST_TIMER = '';
const REQUEST_TIMEOUT = 750;
const REQUEST_URL = './';

export default {
    name: 'suggest-search',

    inheritAttrs: false,

    props: {
        placeholder: {
            type: Object,
        },

        /**
         * Вывод значения из запроса ?query=***,
         * если такой уже имеется
         */
        searchResult: {
            type: String,
            default: '',
        },

        /**
         * Название компонента для вывода результата поиска
         */
        suggestComponent: {
            type: String,
            default: 'suggest-result-simple',
        },
    },

    data() {
        return {
            query: '',
            suggestData: null,
            isSuggestLoading: false,
            isOpenSuggest: false,
        };
    },

    computed: {
        suggestResultClassNames() {
            return {
                'suggest-search__result': true,
                'suggest-search__result--open': this.isOpenSuggest && this.suggestData,
                'suggest-search__result--loading': this.isSuggestLoading,
            };
        },

        setPlaceholder() {
            if (!this.placeholder) {
                return 'Поиск';
            }

            if (
                !Object.prototype.hasOwnProperty.call(this.placeholder, 'desktop')
                || !Object.prototype.hasOwnProperty.call(this.placeholder, 'adaptive')
            ) {
                return 'Поиск';
            }

            return window.outerWidth > 767 ? this.placeholder.desktop : this.placeholder.adaptive;
        },
    },

    methods: {
        openSuggest() {
            document.addEventListener('click', this.missclickHandler);

            if (this.query.length > START_SUGGEST_SYMBOLS) {
                this.isOpenSuggest = true;
            }
        },

        makeSuggest() {
            if (!this.suggestComponent) return; // Если нет компонента для вывода подсказки, то ничего и не выводим

            clearTimeout(REQUEST_TIMER); // сброс таймера

            if (this.query.length > START_SUGGEST_SYMBOLS) {
                REQUEST_TIMER = setTimeout(() => this.request(), REQUEST_TIMEOUT); // Отправляем запрос
            } else {
                this.isOpenSuggest = false; // Скрываем подсказку
            }
        },

        request() {
            this.isSuggestLoading = true; // Вешаем лоадер на саджест

            const query = new FormData();
            query.append('query', this.query);
            query.append('ajax', '');

            ajaxRequest(REQUEST_URL, { query })
                .then((response) => this.successHandler(response))
                .catch((error) => this.errorHandler(error))
                .finally(this.finallyHandler);
        },

        successHandler({ data, textStatus }) {
            try {
                if (data && textStatus === 'success') {
                    this.isOpenSuggest = true;
                    this.suggestData = JSON.parse(data);
                } else {
                    this.suggestData = null;
                    throw new Error('Что-то пошло не так...');
                }
            } catch (e) {
                this.suggestData = null;
                console.log('Что-то пошло не так...', e);
            }
        },

        errorHandler(error) {
            globalErrorHandler(error);
            this.isOpenSuggest = false;
        },

        finallyHandler() {
            this.isSuggestLoading = false; // Снимаем лоадер с саджеста
        },

        missclickHandler(evt) {
            const isClickInside = this.$refs['suggest-search'].contains(evt.target);

            if (!isClickInside) {
                this.isOpenSuggest = false;
                document.removeEventListener('click', this.missclickHandler);
            }
        },
    },

    created() {
        this.query = this.searchResult;
        document.addEventListener('click', this.missclickHandler);
    },
};
</script>
